<script type="text/javascript">
    import {http} from "../../http";
    export default {
        data() {
            return {
            }
        },
        mounted() {
            $('#invalid-eu-vat-modal').modal('show');

        },
        methods: {
            hideModal() {
                $('#invalid-eu-vat-modal').modal('hide');
            }
        },
        computed: {
            tax_id() {
                return Config.get('countries.'+ locale +'.tax_id') ?? Config.get('app.default_tax_name');
            },
        }
    }
</script>

<template id="invalid-eu-vat">
    <div class="modal-dialog invalid-eu-vat">

        <div class="modal-content">
            <form>
                <div class="modal-body p-0">
                    <div>

                        <h1 class="text-center m-b-0">{{ trans('subscription.eu_vat_popup_title') }}</h1>

                        <p class="text-muted m-b-20 m-t-0 text-center">{{ trans('subscription.eu_vat_popup_subtitle') }}</p>

                        <div class="text-center">

                            <div class="m-b-20">
                                <i class="zmdi zmdi-info-outline" style="font-size: 70px;"></i>
                            </div>

                            <p>
                                <span>{{ trans('subscription.eu_vat_popup_1') }}</span>
                                <br><br>
                                <span v-sanitize-html="trans('subscription.eu_vat_popup_2')"></span>
                            </p>

                            <small class="text-muted block">{{ trans('help.mailchimp_text_3', { 'support_email' : $store.state.support_email}) }}</small>

                            <a href="" class="btn btn-default btn-lg m-t-20 m-r-20" @click.prevent="hideModal"><i class="zmdi zmdi-close m-r-10"></i>{{ trans('global.close') }}</a>
                            <a href="/app/settings/subscription?open-invoice-info=1" class="btn btn-custom btn-lg m-t-20" >{{ trans('subscription.update_vat_number', {tax_id}) }} <i class="zmdi zmdi-arrow-right m-l-10"></i> </a>

                        </div>

                    </div>
                </div>

            </form>
        </div>
    </div>
</template>